import React, { useState } from 'react';
import { arrayOf, number, object, shape, string } from 'prop-types';
import { cx } from '@emotion/css';

import Overlay from 'Component/Overlay';

import PopUpMoreInfo from './PopUpMoreInfo';
import { styContainer, styNotationBox, styBtnMore } from './style';

const SpecialNotation = (props) => {
  const { className, overlayPosition, specialNotation, style, totalShow } = props;

  const [show, setShow] = useState(false);
  const totalHidden = specialNotation?.length > totalShow ? specialNotation.length - totalShow : 0;

  if (!specialNotation?.length) return null;

  return (
    <>
      <div className={cx(styContainer, className)} style={style} data-testid="divSpecialNotation">
        {specialNotation.slice(0, totalShow).map((v, idx) => (
          <Overlay text={v.description} placement={overlayPosition} key={v.code}>
            <div className={styNotationBox} data-testid={`divSpecialCode-${idx}`}>
              {v.code}
            </div>
          </Overlay>
        ))}
        {totalHidden > 0 && (
          <div
            role="button"
            className={styBtnMore}
            onClick={() => setShow(true)}
            data-testid="divSpecialPlus"
          >
            {`+${totalHidden}`}
          </div>
        )}
      </div>
      <PopUpMoreInfo
        show={show}
        scrollable
        onHide={() => setShow(false)}
        specialNotation={specialNotation}
      />
    </>
  );
};

SpecialNotation.propTypes = {
  className: string,
  overlayPosition: string,
  specialNotation: arrayOf(
    shape({
      code: string,
      description: string,
    })
  ),
  style: object,
  totalShow: number,
};

SpecialNotation.defaultProps = {
  className: '',
  overlayPosition: 'top',
  specialNotation: [],
  style: {},
  totalShow: 5,
};

export default SpecialNotation;
